export const SET_EXTERNAL_URL = "SET_EXTERNAL_URL";